import { gql } from 'apollo-boost';

export const IS_TEAM_HAS_UNPAID_INVOICE = gql`
  query isTeamHasUnpaidInvoice {
    isTeamHasUnpaidInvoice
  }
`;
